import * as React from "react";
import { Intent, Spinner } from "@blueprintjs/core";
import "./PlaceholderText.css";
import { isLoading, loading, Loading } from "../../Loading";
import { Document, Page } from "react-pdf";
import { delay } from "../../system/delay";

interface PlaceholderTextProps {
    questionText: string;
    isTitle: boolean;
}

export class PlaceholderText extends React.Component<PlaceholderTextProps> {
    constructor(props: PlaceholderTextProps) {
        super(props);
    }

    render() {
        return (
            <div className={this.props.isTitle ? "title" : "regular"} >
               {this.props.questionText}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/placeholders/PlaceholderText.tsx